import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";

export const FALLBACK_COUPON = {
  title: "Smog Check Special",
  description: "Get $10 OFF any Smog Check service at our Hayward station — no expiration date.",
  discount_type: "amount",
  discount_value: 10,
  code: "BAYSMOG10",
  terms: "Mention or show this coupon at time of service · Smog certificate fee may apply · Not valid with other offers",
};

export const discountText = (c) =>
  c.discount_type === "percent"
    ? `${c.discount_value}% OFF`
    : `$${Number.isInteger(c.discount_value) ? c.discount_value : c.discount_value.toFixed(2)} OFF`;

export const useCoupons = () => {
  const [coupons, setCoupons] = useState(null);
  useEffect(() => {
    axios
      .get(`${API}/coupons?_t=${Date.now()}`)
      .then((r) => setCoupons(r.data))
      .catch(() => setCoupons([]));
  }, []);
  return coupons;
};
